import script from "./ber-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./ber-input.vue?vue&type=script&setup=true&lang=ts"

import "./ber-input.vue?vue&type=style&index=0&id=97285b24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97285b24"]])

export default __exports__